import { GroupsGroupResource } from '../types'
import { FIVE_MINUTES } from '../utils/time'
import { useApiPaginator } from './use_api'

export const useGroupsGroups = () => {
  return useApiPaginator<GroupsGroupResource>(
    {
      url: '/me/groups',
      data: {
        perPage: 100,
        fields: {
          Group: [
            'can_create_conversation',
            'can_create_conversation_reason_code',
            'name',
            'header_image',
            'memberships_count',
          ],
        },
        order: 'name',
      },
      app: 'groups',
    },
    { staleTime: FIVE_MINUTES }
  )
}

export const useCanDisplayGroupsGroups = () => {
  const { data: groups = [] } = useGroupsGroups()
  return groups?.length > 0
}
